export default "__VITE_ASSET__dd4d8767__"